import { createAction } from 'redux-actions';

export const SET_IS_AUTHENTICATED = 'USER.SET_USER_AUTHENTICATED';
export const setIsAuthenticated = createAction(SET_IS_AUTHENTICATED);

export const SET_IS_PRE_AUTHENTICATION_PHASE =
  'USER.SET_IS_PRE_AUTHENTICATION_PHASE';
export const setIsPreAuthenticationPhase = createAction(
  SET_IS_PRE_AUTHENTICATION_PHASE
);

export const USER_SIGNOUT = 'USER.USER_SIGNOUT';
export const userSignout = createAction(USER_SIGNOUT);

export const AUTO_LOGIN_ATTEMPT = 'USER.AUTO_LOGIN_ATTEMPT';
export const autoLoginAttempt = createAction(AUTO_LOGIN_ATTEMPT);

export const ON_LOGIN_SUCCESS = 'USER.ON_LOGIN_SUCCESS';
export const onLoginSuccess = createAction(ON_LOGIN_SUCCESS);

export const SET_CURRENT_CITY_EVERYWHERE = 'USER.SET_CURRENT_CITY_EVERYWHERE';
export const setCurrentCityEverywhere = createAction(
  SET_CURRENT_CITY_EVERYWHERE
);

export const SET_CURRENT_CITY = 'USER.SET_CURRENT_CITY';
export const setCurrentCity = createAction(SET_CURRENT_CITY);

export const SET_DEFAULT_CITY = 'USER.SET_DEFAULT_CITY';
export const setDefaultCity = createAction(SET_DEFAULT_CITY);

export const SET_CONTACT_EMAIL_INFLIGHT = 'USER.SET_CONTACT_EMAIL_INFLIGHT';
export const setContactEmailInFlight = createAction(SET_CONTACT_EMAIL_INFLIGHT);

export const SET_HELP_CENTER_EMAIL_INFLIGHT =
  'USER.SET_HELP_CENTER_EMAIL_INFLIGHT';
export const setHelpCenterEmailInFlight = createAction(
  SET_HELP_CENTER_EMAIL_INFLIGHT
);

export const SET_HELP_CENTER_EMAIL_SUCCESSFUL =
  'USER.SET_HELP_CENTER_EMAIL_SUCCESSFUL';
export const setHelpCenterEmailSuccessful = createAction(
  SET_HELP_CENTER_EMAIL_SUCCESSFUL
);

export const STORE_USER_ATTRIBUTES = 'USER.STORE_USER_ATTRIBUTES';
export const storeUserAttributes = createAction(STORE_USER_ATTRIBUTES);

export const SET_AUTHORIZED_CITIES = 'USER.SET_AUTHORIZED_CITIES';
export const setAuthorizedCities = createAction(SET_AUTHORIZED_CITIES);

export const SET_USER_FIRST_NAME = 'USER.SET_USER_FIRST_NAME';
export const setUserFirstName = createAction(SET_USER_FIRST_NAME);

export const SET_USER_LAST_NAME = 'USER.SET_USER_LAST_NAME';
export const setUserLastName = createAction(SET_USER_LAST_NAME);

export const SET_IS_ADMIN = 'USER.SET_IS_ADMIN';
export const setIsAdmin = createAction(SET_IS_ADMIN);

export const SERVER_RETURNED_USER_RIGHTS = 'USER.SERVER_RETURNED_USER_RIGHTS';
export const serverReturnedUserRights = createAction(
  SERVER_RETURNED_USER_RIGHTS
);

export const INITIATE_COGNITO_AUTH_SETUP = 'USER.INITIATE_COGNITO_AUTH_SETUP';
export const initiateCognitoAuthSetup = createAction(
  INITIATE_COGNITO_AUTH_SETUP
);

export const USER_SWITCHED_CITY = 'USER.USER_SWITCHED_CITY';
export const userSwitchedCity = createAction(USER_SWITCHED_CITY);
